import { useCallback, useEffect, useRef } from 'react';
/**
 * Manage setTimeout
 *
 * @param {() => void} callback Callback function to execute when the time out elapses
 * @param {number} delay The number of milliseconds until the callback function executes
 * @returns {Timeout}
 * @example
 * useTimeout(() => console.log('Timed out'), 3000);
 */
export var useTimeout = function (callback, delay) {
    var callbackRef = useRef(callback);
    // eslint-disable-next-line no-undef
    var timeoutRef = useRef();
    useEffect(function () {
        callbackRef.current = callback;
    }, [callback]);
    var set = useCallback(function () {
        timeoutRef.current = setTimeout(callbackRef.current, delay);
    }, [delay]);
    var clear = useCallback(function () {
        timeoutRef.current && clearTimeout(timeoutRef.current);
    }, []);
    useEffect(function () {
        set();
        return clear;
    }, [delay, set, clear]);
    var reset = useCallback(function () {
        clear();
        set();
    }, [clear, set]);
    return { clear: clear, reset: reset };
};
